import { render, staticRenderFns } from "./RedeemProdukDetail.vue?vue&type=template&id=3cca23d5&scoped=true"
import script from "./RedeemProdukDetail.vue?vue&type=script&lang=js"
export * from "./RedeemProdukDetail.vue?vue&type=script&lang=js"
import style0 from "./RedeemProdukDetail.vue?vue&type=style&index=0&id=3cca23d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cca23d5",
  null
  
)

export default component.exports